module.exports = __webpack_public_path__ + "img/logo.c929a4aa.svg";